(() => {
  const root = document.querySelector('[data-nt-welcome]');
  if (!root || root.dataset.ready) return;
  const dialog = root.querySelector('[data-nt-welcome-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  root.dataset.ready = 'true';
  const texts = JSON.parse(root.querySelector('[data-nt-welcome-text]').textContent);
  const form = root.querySelector('form');
  const brand = root.querySelector('[data-nt-welcome-brand]');
  const model = root.querySelector('[data-nt-welcome-model]');
  const year = root.querySelector('[data-nt-welcome-year]');
  const email = root.querySelector('[data-nt-welcome-email]');
  const consent = root.querySelector('[data-nt-welcome-consent]');
  const tags = root.querySelector('[data-nt-welcome-tags]');
  const submit = root.querySelector('[data-nt-welcome-submit]');
  const status = root.querySelector('[data-nt-welcome-status]');
  const launcher = root.querySelector('[data-nt-welcome-open]');
  const success = root.querySelector('[data-nt-welcome-success]');
  const fields = root.querySelector('[data-nt-welcome-fields]');
  const custom = Object.fromEntries(['brand', 'model', 'year'].map(key => [key, {
    input: root.querySelector('[data-nt-welcome-custom-' + key + ']'),
    wrap: root.querySelector('[data-nt-welcome-custom-' + key + '-wrap]')
  }]));
  const options = window.NTVehicleOptions || {};
  const storageKey = 'nt_welcome20_v1';
  let state = {};
  let lastFocus = null;
  let submitting = false;
  try { state = JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch (_) {}
  if (typeof state !== 'object' || Array.isArray(state)) state = {};
  const save = () => { try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {} };
  const other = '__other__';
  const compare = (a, b) => a.localeCompare(b, 'en', { numeric: true });
  const fill = (select, values, placeholder) => {
    select.replaceChildren(new Option(placeholder, ''));
    values.forEach(value => select.add(new Option(value, value)));
    select.add(new Option(texts.other, other));
    select.disabled = false;
  };
  const setCustom = (key, active) => {
    custom[key].wrap.hidden = !active;
    custom[key].input.disabled = !active;
    custom[key].input.required = active;
    if (!active) custom[key].input.value = '';
  };
  const reset = (select, placeholder) => { select.replaceChildren(new Option(placeholder, '')); select.disabled = true; };
  const resolved = (select, key) => select.value === other ? custom[key].input.value.trim() : select.value;
  const clean = value => String(value || '').replace(/[,\r\n|]/g, ' ').replace(/\s+/g, ' ').trim();
  const updateTags = () => {
    const b = clean(resolved(brand, 'brand'));
    const m = clean(resolved(model, 'model'));
    const y = clean(resolved(year, 'year'));
    const values = ['newsletter', 'nt-welcome20', 'source:homepage-popup'];
    if (b) values.push('newsletter-brand:' + b);
    if (m) values.push('newsletter-model:' + m);
    if (y) values.push('newsletter-year:' + y);
    if (b && m && y) values.push('newsletter-bike:' + b + '|' + m + '|' + y);
    tags.value = values.join(',');
  };
  const allBrands = Object.keys(options).sort(compare);
  allBrands.forEach(value => { if (![...brand.options].some(option => option.value === value)) brand.add(new Option(value, value), brand.options.length - 1); });
  brand.addEventListener('change', () => {
    setCustom('brand', brand.value === other);
    setCustom('model', false);
    setCustom('year', false);
    reset(year, texts.selectModelFirst);
    if (!brand.value) reset(model, texts.selectBrandFirst);
    else {
      fill(model, Object.keys(options[brand.value] || {}).sort(compare), texts.selectModel);
      if (brand.value === other) { model.value = other; model.dispatchEvent(new Event('change')); }
    }
    updateTags();
  });
  model.addEventListener('change', () => {
    setCustom('model', model.value === other);
    setCustom('year', false);
    if (!model.value) reset(year, texts.selectModelFirst);
    else {
      const years = (options[brand.value]?.[model.value] || []).map(String).sort((a, b) => Number(b) - Number(a));
      fill(year, years, texts.selectYear);
      if (model.value === other) { year.value = other; year.dispatchEvent(new Event('change')); }
    }
    updateTags();
  });
  year.addEventListener('change', () => { setCustom('year', year.value === other); updateTags(); });
  Object.values(custom).forEach(({ input }) => input.addEventListener('input', () => { input.setCustomValidity(''); updateTags(); }));
  const subscribed = root.dataset.knownSubscriber === 'true' || state.subscribed === true;
  const pendingKey = 'nt_welcome_fixed_pending_v1';
  let pendingAt = 0;
  try { pendingAt = Number(sessionStorage.getItem(pendingKey) || 0); } catch (_) {}
  const pendingFresh = pendingAt > Date.now() - 900000 && pendingAt <= Date.now() + 30000;
  const forcedPreview = new URLSearchParams(location.search).get('nt_welcome') === '1';
  const isTargetTheme = String(window.Shopify?.theme?.id) === '167792247003';
  const isDraft = window.Shopify?.theme?.role !== 'main';
  const active = isTargetTheme && ((root.dataset.launchReady === 'true' && !isDraft) || (isDraft && (forcedPreview || (pendingFresh && root.querySelector('[data-nt-welcome-server-success]')))));
  const code = root.dataset.discountCode || '';
  const ready = active && /^[A-Za-z0-9_-]{3,64}$/.test(code);
  submit.disabled = !ready;
  launcher.hidden = subscribed || !ready;
  if (!ready) status.textContent = texts.preview;
  if (isDraft && ready) {
    const back = form.querySelector('[name="return_to"]');
    if (back) {
      const url = new URL(back.value, location.origin);
      url.searchParams.set('preview_theme_id', '167792247003');
      url.searchParams.set('nt_welcome', '1');
      back.value = url.pathname + url.search + url.hash;
    }
  }
  const showSuccess = () => {
    root.querySelector('[data-nt-welcome-code]').textContent = code;
    root.querySelector('[data-nt-welcome-copy]').disabled = false;
    root.querySelector('.nt-welcome__shop').href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcollections%2Ffairing-kits';
    try { sessionStorage.removeItem(pendingKey); } catch (_) {}
    fields.hidden = true;
    success.hidden = false;
    state = { subscribed: true };
    save();
    launcher.hidden = true;
  };
  const open = () => {
    if (dialog.open) return;
    if (document.querySelector('dialog[open]')) return;
    lastFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('nt-welcome-open');
    requestAnimationFrame(() => (success.hidden ? brand : root.querySelector('[data-nt-welcome-success-title]')).focus({ preventScroll: true }));
  };
  const close = () => {
    if (submitting) return;
    state.dismissedUntil = Date.now() + Math.max(1, Number(root.dataset.dismissDays) || 7) * 86400000;
    save();
    dialog.close();
  };
  root.querySelectorAll('[data-nt-welcome-close]').forEach(button => button.addEventListener('click', close));
  launcher.addEventListener('click', open);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('nt-welcome-open');
    if (lastFocus?.isConnected && !lastFocus.hidden) lastFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  form.addEventListener('submit', event => {
    if (!ready) { event.preventDefault(); return; }
    const b = resolved(brand, 'brand'), m = resolved(model, 'model'), y = resolved(year, 'year');
    if (submitting) { event.preventDefault(); return; }
    if (year.value === other && (!/^\d{4}$/.test(y) || Number(y) < 1900 || Number(y) > new Date().getUTCFullYear() + 2)) custom.year.input.setCustomValidity(texts.yearError);
    if (!b || !m || !y || !consent.checked || !email.value.trim() || !form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }
    updateTags();
    tags.value += ',nt-welcome-consent:v1';
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (_) {}
    submitting = true;
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    status.textContent = texts.submitting;
    launcher.hidden = true;
    setTimeout(() => {
      if (!submitting) return;
      submitting = false;
      submit.disabled = !ready;
      submit.removeAttribute('aria-busy');
      status.textContent = texts.retry;
      launcher.hidden = state.subscribed === true || root.dataset.knownSubscriber === 'true' || !ready;
    }, 30000);
  });
  root.querySelector('[data-nt-welcome-copy]').addEventListener('click', async event => {
    const button = event.currentTarget;
    try { await navigator.clipboard.writeText(root.querySelector('[data-nt-welcome-code]').textContent.trim()); button.textContent = texts.copied; }
    catch (_) {
      const selection = getSelection(), range = document.createRange();
      range.selectNodeContents(root.querySelector('[data-nt-welcome-code]'));
      selection.removeAllRanges(); selection.addRange(range);
    }
  });
  const returnedToPopup = ready && pendingFresh;
  const successPreview = isTargetTheme && isDraft && forcedPreview && new URLSearchParams(location.search).get('nt_welcome_state') === 'success';
  if (successPreview || (returnedToPopup && root.querySelector('[data-nt-welcome-server-success]'))) {
    showSuccess();
    open();
  } else if (returnedToPopup && root.querySelector('[data-nt-welcome-server-error]')) open();
  else if (ready && !subscribed && (window.Shopify?.designMode || Number(state.dismissedUntil || 0) < Date.now())) {
    setTimeout(() => {
      if (!document.hidden) open();
      else document.addEventListener('visibilitychange', () => { if (!document.hidden && !state.subscribed) open(); }, { once: true });
    }, Math.max(3000, Number(root.dataset.delay) || 6000));
  }
  if (new URLSearchParams(location.search).get('nt_welcome') === '1') open();
  window.addEventListener('pageshow', () => {
    submitting = false;
    submit.disabled = !ready;
    submit.removeAttribute('aria-busy');
    status.textContent = '';
    launcher.hidden = state.subscribed === true || root.dataset.knownSubscriber === 'true' || !ready;
  });
  if (window.Shopify?.designMode) document.addEventListener('shopify:section:select', event => { if (event.target.contains(root)) open(); });
})();
